import secureLocalStorage from 'react-secure-storage';
import { saveLocationData } from './apiUtils'; // Import the new utility function

export const getLocationAndSave = async (
  setLatitude,
  setLongitude,
  setAccuracy,
  setTimestamp,
  // setViewport,
  player,
  hooks = {},
) => {
  const options = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
  };

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        const timestamp = position.timestamp;

        setLatitude(latitude);
        setLongitude(longitude);
        setAccuracy(accuracy);
        setTimestamp(timestamp);
        // setViewport((prevViewport) => ({
        //   ...prevViewport,
        //   latitude,
        //   longitude,
        // }));

        // console.log(latitude, longitude);
        secureLocalStorage.setItem('latitude', JSON.stringify(latitude));
        secureLocalStorage.setItem('longitude', JSON.stringify(longitude));

        hooks?.onPermissionGranted?.(position);
        hooks?.onSaveAttempted?.(position);
        try {
          await saveLocationData(
            latitude,
            longitude,
            accuracy,
            timestamp,
            player.token,
          );
          hooks?.onSaved?.(position);
        } catch (err) {
          hooks?.onSaveFailed?.(err);
          console.error('Error saving location:', err.message);
        }

        resolve(position);
      },
      (error) => {
        const permissionDenied =
          error?.code === 1 || error?.code === error?.PERMISSION_DENIED;
        if (!permissionDenied) {
          console.error('Error getting location:', error);
        }
        reject(error);
      },
      options,
    );
  });
};
